require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-relazioni-e-conferenze-flora-ruchat-roncati-in-riva-san-vitale-virginia-tech-riva-san-vitale-8-february-2022.json") })
        }
      }, "path---en-relazioni-e-conferenze-flora-ruchat-roncati-in-riva-san-vitale-virginia-tech-riva-san-vitale-8-february-2022");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-relazioni-e-conferenze-flora-ruchat-roncati-in-riva-san-vitale-virginia-tech-riva-san-vitale-8-february-2022!./.cache/json/en-relazioni-e-conferenze-flora-ruchat-roncati-in-riva-san-vitale-virginia-tech-riva-san-vitale-8-february-2022.json
// module id = 607
// module chunks = 231608221292675